import ko from "knockout";
import $ from "jquery";
import * as _ from "underscore";
import filterUtil from "flow/filter/filterUtil";
import register from "flow/knockout/register";

register.registerKnockoutBinding("filteredForEach", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const tableParent = $(element).parent();
        if (!($(element).is("tbody") && tableParent.is("table"))) {
            throw new Error("filteredForEach only works on tbody inside table!");
        }

        const bindingParameters = ko.unwrap(valueAccessor());

        const newValueAccessor = function () {
            return bindingParameters.listItems;
        };
        const returnValue = ko.bindingHandlers.foreach.init(
            element,
            newValueAccessor,
            allBindingsAccessor,
            viewModel,
            bindingContext
        );

        return returnValue;
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const bindingParameters = ko.unwrap(valueAccessor());

        if (bindingParameters.applyFilterBinding && bindingParameters.applyFilterBinding() === false) {
            return undefined;
        }

        const filteredListItems = filterUtil.getFilteredList(bindingParameters.listItems(), bindingParameters.filters);

        if (bindingParameters.recordsCount && ko.isObservable(bindingParameters.recordsCount)) {
            bindingParameters.recordsCount(filteredListItems.length);
        }

        const newValueAccessor = function () {
            return ko.observableArray(filteredListItems);
        };
        const returnValue = ko.bindingHandlers.foreach.update(
            element,
            newValueAccessor,
            allBindingsAccessor,
            viewModel,
            bindingContext
        );

        return returnValue;
    }
});
